import { MutableRefObject, useEffect, useMemo, useRef } from 'react'

export function useEffectWithRefs<Refs>(
  callback: (refs: MutableRefObject<Refs>) => void,
  dependencies: any[],
  refs: Refs
) {
  const refsRef = useRef(refs)
  refsRef.current = refs
  useEffect(() => callback(refsRef), dependencies)
}

export function useMemoWithRefs<Memoized, Refs>(
  callback: (refs: MutableRefObject<Refs>) => Memoized,
  dependencies: any[],
  refs: Refs
): Memoized {
  const refsRef = useRef(refs)
  refsRef.current = refs
  return useMemo(() => callback(refsRef), dependencies)
}
